import React from 'react';
import './skillMap.scss';
import Dashboard from './Dashboard/dashboard';

const SkillMap = () => {
  const SKILLS = 'Skills';

  return (
    <div className="skill-map-outer-layer">
      <div className="skill-map">
        <h1 className="title-text">{SKILLS}</h1>

        <Dashboard />
      </div>
    </div>
  );
};

export default SkillMap;
